(function () {
  const observer = new MutationObserver(() => {
    const iframe = document.getElementById('merchantwidgetiframe');
    if (iframe) {
      iframe.setAttribute(
        'title',
        'Shopping assistance and merchant promotions'
      );
      iframe.setAttribute(
        'aria-label',
        'Shopping assistance and merchant promotions'
      );
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

//Wishlist Fix
document.addEventListener('DOMContentLoaded', function() {
  // Find the wishlist button and add aria-label
  const wishlistButton = document.querySelector('.swym-icon.heart-unfilled.swym-header-launcher-icon');
  
  if (wishlistButton && wishlistButton.getAttribute('role') === 'button') {
    // Check if it doesn't already have an accessible name
    if (!wishlistButton.getAttribute('aria-label') && 
        !wishlistButton.getAttribute('aria-labelledby') &&
        !wishlistButton.textContent.trim()) {
      wishlistButton.setAttribute('aria-label', 'Wishlist');
    }
  }
});

  (function() {
    'use strict';
    
    console.log('🔧 Swym Accessibility Fix - Starting...');
    
    function fixSwymCloseButtons() {
      const closeButtons = document.querySelectorAll('.swym-storefront-layout-action-close-button');
      
      console.log('🔍 Found ' + closeButtons.length + ' close buttons');
      
      closeButtons.forEach(function(btn, index) {
        if (!btn.getAttribute('aria-label')) {
          btn.setAttribute('aria-label', 'Close');
          console.log('✅ Fixed button #' + (index + 1));
        }
      });
    }
    
    function fixSwymMenus() {
      const tooltipOptions = document.getElementById('swym-storefront-layout-action-tooltip-options');
      if (tooltipOptions) {
        tooltipOptions.removeAttribute('role');
        tooltipOptions.setAttribute('role', 'tooltip');
        console.log('✅ Fixed tooltip menu');
      }
    }
    
    function runAllFixes() {
      console.log('🚀 Running Swym fixes...');
      fixSwymCloseButtons();
      fixSwymMenus();
      console.log('✨ Done!');
    }
    
    // Run multiple times to catch late-loading content
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runAllFixes);
    } else {
      runAllFixes();
    }
    
    setTimeout(runAllFixes, 1000);
    setTimeout(runAllFixes, 3000);
    setTimeout(runAllFixes, 5000);
    
  })();
// AGGRESSIVE FIX for addon checkboxes
(function() {
  'use strict';
  
  console.log('🔧 Addon Checkbox Accessibility Fix - AGGRESSIVE MODE');
  
  // Track which ones we've already fixed
  var fixedElements = new WeakSet();
  
  function fixAddonCheckboxes() {
    var fixed = 0;
    var alreadyFixed = 0;
    
    document.querySelectorAll('.custom-checkbox').forEach(function(label) {
      // Skip if already fixed
      if (fixedElements.has(label)) {
        alreadyFixed++;
        return;
      }
      
      var checkbox = label.querySelector('.addon-checkbox');
      var checkmark = label.querySelector('.checkmark');
      var existingHidden = label.querySelector('.visually-hidden');
      
      if (!checkbox || !checkmark) return;
      
      // If visually-hidden already exists and has text, mark as fixed
      if (existingHidden && existingHidden.textContent.trim()) {
        fixedElements.add(label);
        alreadyFixed++;
        return;
      }
      
      // Need to fix this one
      var addonProduct = label.closest('.addon-product');
      var titleElement = addonProduct ? addonProduct.querySelector('.addon-product__title') : null;
      var productTitle = titleElement ? titleElement.textContent.trim() : 'addon product';
      
      // Remove any existing empty visually-hidden spans
      // Remove only EMPTY visually-hidden spans
      if (existingHidden && !existingHidden.textContent.trim()) {
        existingHidden.remove();
      }

      // If checkbox already has aria-label or aria-labelledby, do nothing
      if (
        checkbox.hasAttribute('aria-label') ||
        checkbox.hasAttribute('aria-labelledby')
      ) {
        fixedElements.add(label);
        return;
      }
      // Create new visually-hidden span
      var span = document.createElement('span');
      span.className = 'visually-hidden';
      span.textContent = 'Add ' + productTitle;
      span.setAttribute('data-injected', 'true');
      
      // Insert after checkmark
      if (checkmark.nextSibling) {
        checkmark.parentNode.insertBefore(span, checkmark.nextSibling);
      } else {
        label.appendChild(span);
      }
      
      // Mark as fixed
      fixedElements.add(label);
      fixed++;
      
      console.log('✅ Fixed: ' + productTitle);
    });
    
    if (fixed > 0) {
      console.log('📊 Fixed: ' + fixed + ', Already fixed: ' + alreadyFixed);
    }
  }
  
  // Run immediately
  fixAddonCheckboxes();
  
  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAddonCheckboxes);
  }
  
  // Run at intervals (catches late-loading content)
  var intervals = [100, 300, 500, 1000, 2000, 3000, 5000];
  intervals.forEach(function(delay) {
    setTimeout(fixAddonCheckboxes, delay);
  });
  
  // Watch for AJAX-loaded content
  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      var needsCheck = false;
      
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if ((node.classList && node.classList.contains('addon-product')) ||
                (node.querySelector && node.querySelector('.addon-product'))) {
              needsCheck = true;
              console.log('🔄 New addon product detected, re-checking...');
            }
          }
        });
      });
      
      if (needsCheck) {
        setTimeout(fixAddonCheckboxes, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    console.log('👀 Watching for dynamically loaded content...');
  }
  
  // Also fix on any user interaction (in case content loads on scroll/click)
  ['scroll', 'click', 'touchstart'].forEach(function(eventType) {
    document.addEventListener(eventType, function() {
      setTimeout(fixAddonCheckboxes, 100);
    }, { once: true, passive: true });
  });
  
  console.log('✨ Aggressive fix initialized');
  
})();